// @ts-check
import React from 'react';
import { createPortal } from 'react-dom';
import SettingsContent from './SettingsContent';
import './SettingsSheet.css';

/**
 * Bottom-sheet wrapper around {@link SettingsContent} — the same settings panel
 * the student dashboard top-bar opens (theme, add-to-home-screen, account
 * switch, sign out). Extracted so non-dashboard surfaces (e.g. /library, which
 * has no bottom nav) can offer the identical settings UX from their header.
 *
 * Renders nothing while closed; portals to <body> so it floats above whatever
 * full-screen view is mounted underneath.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {() => void} props.onSignOut
 * @param {Array<{ authing_user_id: string, display_name: string | null, role: string }>} [props.familyMembers]
 * @param {string} [props.currentStudentId]
 * @param {(id: string) => void} [props.onSwitchAccount]
 * @param {string} [props.studentId] - enables the per-child sections (出生年月, 登录信息…)
 * @param {string | null} [props.birthYm]
 * @param {(ym: string) => void} [props.onBirthYmSaved]
 */
function SettingsSheet({ isOpen, onClose, onSignOut, familyMembers, currentStudentId, onSwitchAccount, studentId, birthYm, onBirthYmSaved }) {
  if (!isOpen) return null;

  return createPortal(
    <div className="settings-sheet-overlay" onClick={onClose} data-testid="settings-sheet-overlay">
      <div className="settings-sheet-shell" onClick={(e) => e.stopPropagation()}>
        <div className="settings-sheet-grabber" />
        <div className="settings-sheet-body" data-testid="settings-sheet-body">
          <SettingsContent
            onSignOut={onSignOut}
            familyMembers={familyMembers}
            currentStudentId={currentStudentId}
            onSwitchAccount={onSwitchAccount}
            studentId={studentId}
            birthYm={birthYm}
            onBirthYmSaved={onBirthYmSaved}
          />
        </div>
      </div>
    </div>,
    document.body
  );
}

export default SettingsSheet;
